 <div class="form" *ngIf="question">

    <div [ngSwitch]="question.type.id">
      <div class="q" *ngSwitchCase="eQuestionType.Multi">
        <que-multi-question-display [viewAnswer]="viewAnswer" [isRequierd]="question.requierd" [question]="question"></que-multi-question-display>
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.Autocomplete">
        <que-autocomplete-question-display [viewAnswer]="viewAnswer" [isRequierd]="question.requierd" [question]="question">
        </que-autocomplete-question-display>
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.Mark">
        <que-mark-question-display [viewAnswer]="viewAnswer" [isRequierd]="question.requierd" [question]="question"></que-mark-question-display>
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.FreeText">
        <que-free-text-question-display [viewAnswer]="viewAnswer" [question]="question"></que-free-text-question-display>
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.Number">
        <que-number-question-display [viewAnswer]="viewAnswer"></que-number-question-display>
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.Table">
        <que-table-question-display [viewAnswer]="viewAnswer" [question]="question"></que-table-question-display>
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.PhoneNumber">
        <que-phone-number-question-display [viewAnswer]="viewAnswer" [isPreview]="isPreview" [question]="question"></que-phone-number-question-display>
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.Range">
        <que-range-question-display [viewAnswer]="viewAnswer" [question]="question"></que-range-question-display>
      </div>
      <!-- <div class="warp-btn" *ngSwitchCase="eQuestionType.Send">
        <que-send-button-display [question]="question"></que-send-button-display>
      </div> -->
      <div class="warp-right-btn" *ngSwitchCase="eQuestionType.Link">
        <que-link-display [viewAnswer]="viewAnswer" [question]="question"></que-link-display>
      </div>
      <!-- <div class="warp-btn" *ngSwitchCase="eQuestionType.Next">
        <que-send-button-display [question]="question"></que-send-button-display>
      </div> -->
      <div class="q" *ngSwitchCase="eQuestionType.Fill">
        <que-fill-question-display [viewAnswer]="viewAnswer" [question]="question"></que-fill-question-display>
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.Date">
        <que-date-question-display [viewAnswer]="viewAnswer" [isPreview]="isPreview" [question]="question"></que-date-question-display>
      </div>
      <div *ngSwitchCase="eQuestionType.Divider">
        <!-- <que-divider-line-display></que-divider-line-display> -->
      </div>
      <div *ngSwitchCase="eQuestionType.Signature">
        <que-signature-display [viewAnswer]="viewAnswer" [question]="question"  [isDisplay]="true"></que-signature-display>
      </div>
      <div class="t" *ngSwitchCase="eQuestionType.Title">
        <!-- <que-title-question-display [question]="question"></que-title-question-display> -->
      </div>
      <div class="t" *ngSwitchCase="eQuestionType.Text">
        <que-text-to-question-display [viewAnswer]="viewAnswer" [question]="question"></que-text-to-question-display>
         <!-- <que-text-to-question [formControl]="questionForm2" [index]="index">
    </que-text-to-question> -->
      </div>
      <div class="q" *ngSwitchCase="eQuestionType.QuestionsGroup">
        <que-questions-group-display [viewAnswer]="viewAnswer" [question]="question" [isPreview]="isPreview"></que-questions-group-display>
      </div>
      <div  class="warp-btn" *ngSwitchCase="eQuestionType.UploadFile">
        <que-upload-file-display [viewAnswer]="viewAnswer" [question]="question" [isDisplay]="isPreview"></que-upload-file-display>
      </div>
      <div  class="q" *ngSwitchCase="eQuestionType.Image">
        <que-image-display [viewAnswer]="viewAnswer" [question]="question"></que-image-display>
      </div>
      <div  class="q" *ngSwitchCase="eQuestionType.UploadFileAdmin">
        <que-upload-file-admin-display [viewAnswer]="viewAnswer" [isPreview]="isPreview"  [question]="question"></que-upload-file-admin-display>
      </div>
       <div  class="q" *ngSwitchCase="eQuestionType.Expense">
        <que-expense-display [viewAnswer]="viewAnswer" [isPreview]="isPreview"  [question]="question"></que-expense-display>
      </div>
    </div>
  </div>
